import React from "react"
import PropTypes from "prop-types"

export default class DairyDropdown extends React.Component{
	static defaultProps = {
		mainDairyId: -1,
		dairiesList: []
	}
	
	static propTypes = {
		mainDairyId: PropTypes.number.isRequired,
		dairiesList: PropTypes.array,
		changeDairy: PropTypes.func.isRequired
	}
	
	constructor(props){
		super(props)
		
		this.state = {
			selectedDairyId: props.mainDairyId
		}
	}
	
	selectNewDairy(event){
		const newDairyId = parseInt(event.target.value)
		
		this.setState({
			selectedDairyId: newDairyId
		}, () => {
			this.props.changeDairy(newDairyId)
		})
	}
	
	render(){
		if(this.props.dairiesList.length < 2){
			return null
		}
		
		const dairyOptions = this.props.dairiesList.map((dairy, index) => (
			<option key={dairy.dairy_id} value={dairy.dairy_id}>{dairy.dairy_name}</option>
		))
		
		return(
			<div>
				<p>Change Diary:</p>
				<select value={this.state.selectedDairyId} onChange={this.selectNewDairy.bind(this)}>
					{dairyOptions}
				</select>
			</div>
		)
	}
}